var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85714 27.8182C7.85714 20.1866 13.9972 14 21.5714 14C27.3496 14 32.2899 17.5992 34.3104 22.6918C34.6309 22.6552 34.9563 22.6364 35.2857 22.6364C40.0196 22.6364 43.8571 26.503 43.8571 31.2727C43.8571 31.7239 43.8227 32.1678 43.7561 32.6016C46.8844 34.3775 49 36.7564 49 40.6364C49 46.36 44.3949 50 38.7143 50H13C6.37258 50 1 45.5867 1 38.9091C1 34.0655 3.82576 30.8905 7.90341 28.9602C7.87275 28.5834 7.85714 28.2025 7.85714 27.8182Z",
    stroke: "url(#paint0_linear_908_844)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.999 37.6364C52.999 33.7564 50.8835 30.3775 47.7551 28.6016C47.8217 28.1678 47.8562 27.7239 47.8562 27.2727C47.8562 22.503 44.0186 18.6364 39.2848 18.6364C38.9554 18.6364 38.6299 18.6552 38.3095 18.6918C36.2889 13.5992 31.3487 10 25.5705 10H23.2891",
    stroke: "#A7BDF7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5703 6C35.3485 6 40.2888 9.59923 42.3093 14.6918C42.6298 14.6552 42.9552 14.6364 43.2846 14.6364C48.0185 14.6364 51.856 18.503 51.856 23.2727C51.856 23.7239 51.8215 24.1678 51.755 24.6016C54.8833 26.3775 56.9989 29.7564 56.9989 33.6364",
    stroke: "#D3DEFB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_844",
    x1: 1,
    y1: 46.8037,
    x2: 49.7205,
    y2: 42.6408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.9a09a0f036c3793dd9f6f6df3df49898.svg";
export { ForwardRef as ReactComponent };